"use client";

import React from "react";
import { Dialog } from "@ariakit/react";

import styles from "../../../../components/ArticleModal/ArticleModal.module.scss";
import { useArticleModalStore } from "../../../../store/useArticleModalStore";
import { ArticleSkeleton } from "../../../../components/skeletons/ArticleSkeleton/ArticleSkeleton";

export default function Loading() {
  const { getIsModalOpen } = useArticleModalStore();

  if (!getIsModalOpen()) {
    return null;
  }

  return (
    <Dialog
      portal={false}
      open
      className={styles.articleModal}
      preventBodyScroll={true}
      backdrop={<div className={styles.backdrop} />}
    >
      <ArticleSkeleton modal={true} />
    </Dialog>
  );
}
